import { render } from "./TestimonialsSectionComponent.vue?vue&type=template&id=174b00d6&scoped=true"
import script from "./TestimonialsSectionComponent.vue?vue&type=script&lang=js"
export * from "./TestimonialsSectionComponent.vue?vue&type=script&lang=js"

import "./TestimonialsSectionComponent.vue?vue&type=style&index=0&id=174b00d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174b00d6"]])

export default __exports__